// LogoutPage.js
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearCart } from "../../../store/cartSlice";
import LogoutConfirmationModal from "./LogoutConfirmationModal";

function LogoutPage() {
  const [customer, setCustomer] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const session = localStorage.getItem("customer"); // ✅ sessionStorage
    setCustomer(session ? JSON.parse(session) : null);
  }, []);

  const [showModal, setShowModal] = useState(false);
  const handleLogout = () => {
    setShowModal(true);
  };
  const confirmLogout = () => {
    setShowModal(false);
    localStorage.removeItem("customer");
    localStorage.removeItem("checkoutAddress");
    // Clear Redux cart
    dispatch(clearCart());
    // (Optional) clear cookies if you add them later
    // document.cookie = "token=; Max-Age=0; path=/;";
    navigate("/page/categories", { replace: true });
    console.log("User logged out");
  };

  const cancelLogout = () => {
    setShowModal(false);
  };
  return (
    <>
      <div>
        {customer ? (
          <button
            className="btn btn-danger bg-danger"
            style={{ backgroundColor: "#4c934c", color: "white" }}
            onClick={handleLogout}
          >
            Logout
          </button>
        ) : (
          <Link to="/login">Login</Link>
        )}
      </div>

      <LogoutConfirmationModal
        show={showModal}
        onConfirm={confirmLogout}
        onCancel={cancelLogout}
      />
    </>
  );
}

export default LogoutPage;
